module.exports = __webpack_public_path__ + "img/authx-form.b3b1f9fc.svg";